import React from "react";
import styles from "./InTaxHeaderBar.module.css";

const YEARS = [2025, 2024, 2023];

export default function InTaxHeaderBar({ year, onYearChange, jurisdiction, onJurisdictionChange }) {
  const { countryCode, provinceOrState, filingStatus } = jurisdiction;

  return (
    <div className={`d-flex align-items-center justify-content-between mb-3 ${styles.bar}`}>
      <div className="d-flex align-items-center gap-2">
        {/* Jurisdiction chips (editable in a later pass) */}
        <span className="badge bg-light text-dark border">{countryCode.toUpperCase()}</span>
        <span className="badge bg-light text-dark border">{provinceOrState.toUpperCase()}</span>
        <span className="badge bg-light text-dark border text-capitalize">{filingStatus}</span>

        <div className="vr mx-2" />

        {/* Year dropdown */}
        <label className="pp-visually-hidden" htmlFor="in-tax-year">Year</label>
        <select
          id="in-tax-year"
          className="form-select form-select-sm"
          value={year}
          onChange={(e) => onYearChange(Number(e.target.value))}
          aria-label="Select tax year"
        >
          {YEARS.map((y) => (
            <option key={y} value={y}>{y}</option>
          ))}
        </select>
      </div>
    </div>
  );
}
